module.exports = __webpack_public_path__ + "img/logo.15c6ff51.svg";